/**
 * Window property Cypress sets on the AUT before app scripts run (`cypress/support/e2e.ts`).
 * `clientConfig.shouldMockServices` treats this as mock mode so E2E uses MockLeadsService, etc.
 */
export const CYPRESS_E2E_PRIME_KEY = '__CYPRESS_MSL_ATTACH_E2E__' as const;
